export interface Country {
  label: string;
  value: string;
  flag: string;
  phonePrefix: string;
}

export const US_COUNTRY_OPTION = { label: 'United States', value: 'US' };

export const US_COUNTRY: Country = {
  label: 'United States',
  value: 'United States',
  flag: '🇺🇸',
  phonePrefix: '+1'
};

export const COUNTRIES_OPTIONS: Array<Country> = [
  {
    label: 'Afghanistan',
    value: 'AF',
    flag: '🇦🇫',
    phonePrefix: '+93'
  },
  {
    label: 'Aland Islands',
    value: 'AX',
    flag: '🇦🇽',
    phonePrefix: '+358-18'
  },
  {
    label: 'Albania',
    value: 'AL',
    flag: '🇦🇱',
    phonePrefix: '+355'
  },
  {
    label: 'Algeria',
    value: 'DZ',
    flag: '🇩🇿',
    phonePrefix: '+213'
  },
  {
    label: 'American Samoa',
    value: 'AS',
    flag: '🇦🇸',
    phonePrefix: '+1-684'
  },
  {
    label: 'Andorra',
    value: 'AD',
    flag: '🇦🇩',
    phonePrefix: '+376'
  },
  {
    label: 'Angola',
    value: 'AO',
    flag: '🇦🇴',
    phonePrefix: '+244'
  },
  {
    label: 'Anguilla',
    value: 'AI',
    flag: '🇦🇮',
    phonePrefix: '+1-264'
  },
  {
    label: 'Antarctica',
    value: 'AQ',
    flag: '🇦🇶',
    phonePrefix: ''
  },
  {
    label: 'Antigua and Barbuda',
    value: 'AG',
    flag: '🇦🇬',
    phonePrefix: '+1-268'
  },
  {
    label: 'Argentina',
    value: 'AR',
    flag: '🇦🇷',
    phonePrefix: '+54'
  },
  {
    label: 'Armenia',
    value: 'AM',
    flag: '🇦🇲',
    phonePrefix: '+374'
  },
  {
    label: 'Aruba',
    value: 'AW',
    flag: '🇦🇼',
    phonePrefix: '+297'
  },
  {
    label: 'Australia',
    value: 'AU',
    flag: '🇦🇺',
    phonePrefix: '+61'
  },
  {
    label: 'Austria',
    value: 'AT',
    flag: '🇦🇹',
    phonePrefix: '+43'
  },
  {
    label: 'Azerbaijan',
    value: 'AZ',
    flag: '🇦🇿',
    phonePrefix: '+994'
  },
  {
    label: 'Bahamas',
    value: 'BS',
    flag: '🇧🇸',
    phonePrefix: '+1-242'
  },
  {
    label: 'Bahrain',
    value: 'BH',
    flag: '🇧🇭',
    phonePrefix: '+973'
  },
  {
    label: 'Bangladesh',
    value: 'BD',
    flag: '🇧🇩',
    phonePrefix: '+880'
  },
  {
    label: 'Barbados',
    value: 'BB',
    flag: '🇧🇧',
    phonePrefix: '+1-246'
  },
  {
    label: 'Belarus',
    value: 'BY',
    flag: '🇧🇾',
    phonePrefix: '+375'
  },
  {
    label: 'Belgium',
    value: 'BE',
    flag: '🇧🇪',
    phonePrefix: '+32'
  },
  {
    label: 'Belize',
    value: 'BZ',
    flag: '🇧🇿',
    phonePrefix: '+501'
  },
  {
    label: 'Benin',
    value: 'BJ',
    flag: '🇧🇯',
    phonePrefix: '+229'
  },
  {
    label: 'Bermuda',
    value: 'BM',
    flag: '🇧🇲',
    phonePrefix: '+1-441'
  },
  {
    label: 'Bhutan',
    value: 'BT',
    flag: '🇧🇹',
    phonePrefix: '+975'
  },
  {
    label: 'Bolivia',
    value: 'BO',
    flag: '🇧🇴',
    phonePrefix: '+591'
  },
  {
    label: 'Bonaire, Saint Eustatius and Saba ',
    value: 'BQ',
    flag: '🇧🇶',
    phonePrefix: '+599'
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'BA',
    flag: '🇧🇦',
    phonePrefix: '+387'
  },
  {
    label: 'Botswana',
    value: 'BW',
    flag: '🇧🇼',
    phonePrefix: '+267'
  },
  {
    label: 'Bouvet Island',
    value: 'BV',
    flag: '🇧🇻',
    phonePrefix: ''
  },
  {
    label: 'Brazil',
    value: 'BR',
    flag: '🇧🇷',
    phonePrefix: '+55'
  },
  {
    label: 'British Indian Ocean Territory',
    value: 'IO',
    flag: '🇮🇴',
    phonePrefix: '+246'
  },
  {
    label: 'Brunei',
    value: 'BN',
    flag: '🇧🇳',
    phonePrefix: '+673'
  },
  {
    label: 'Bulgaria',
    value: 'BG',
    flag: '🇧🇬',
    phonePrefix: '+359'
  },
  {
    label: 'Burkina Faso',
    value: 'BF',
    flag: '🇧🇫',
    phonePrefix: '+226'
  },
  {
    label: 'Burundi',
    value: 'BI',
    flag: '🇧🇮',
    phonePrefix: '+257'
  },
  {
    label: 'Cape Verde',
    value: 'CV',
    flag: '🇨🇻',
    phonePrefix: '+238'
  },
  {
    label: 'Cambodia',
    value: 'KH',
    flag: '🇰🇭',
    phonePrefix: '+855'
  },
  {
    label: 'Cameroon',
    value: 'CM',
    flag: '🇨🇲',
    phonePrefix: '+237'
  },
  {
    label: 'Canada',
    value: 'CA',
    flag: '🇨🇦',
    phonePrefix: '+1'
  },
  {
    label: 'Cayman Islands',
    value: 'KY',
    flag: '🇰🇾',
    phonePrefix: '+1-345'
  },
  {
    label: 'Central African Republic',
    value: 'CF',
    flag: '🇨🇫',
    phonePrefix: '+236'
  },
  {
    label: 'Chad',
    value: 'TD',
    flag: '🇹🇩',
    phonePrefix: '+235'
  },
  {
    label: 'Chile',
    value: 'CL',
    flag: '🇨🇱',
    phonePrefix: '+56'
  },
  {
    label: 'China',
    value: 'CN',
    flag: '🇨🇳',
    phonePrefix: '+86'
  },
  {
    label: 'Christmas Island',
    value: 'CX',
    flag: '🇨🇽',
    phonePrefix: '+61'
  },
  {
    label: 'Cocos Islands',
    value: 'CC',
    flag: '🇨🇨',
    phonePrefix: '+61'
  },
  {
    label: 'Colombia',
    value: 'CO',
    flag: '🇨🇴',
    phonePrefix: '+57'
  },
  {
    label: 'Comoros',
    value: 'KM',
    flag: '🇰🇲',
    phonePrefix: '+269'
  },
  {
    label: 'Democratic Republic of the Congo',
    value: 'CD',
    flag: '🇨🇩',
    phonePrefix: '+243'
  },
  {
    label: 'Republic of the Congo',
    value: 'CG',
    flag: '🇨🇬',
    phonePrefix: '+242'
  },
  {
    label: 'Cook Islands',
    value: 'CK',
    flag: '🇨🇰',
    phonePrefix: '+682'
  },
  {
    label: 'Costa Rica',
    value: 'CR',
    flag: '🇨🇷',
    phonePrefix: '+506'
  },
  {
    label: 'Ivory Coast',
    value: 'CI',
    flag: '🇨🇮',
    phonePrefix: '+225'
  },
  {
    label: 'Croatia',
    value: 'HR',
    flag: '🇭🇷',
    phonePrefix: '+385'
  },
  {
    label: 'Cuba',
    value: 'CU',
    flag: '🇨🇺',
    phonePrefix: '+53'
  },
  {
    label: 'Curacao',
    value: 'CW',
    flag: '🇨🇼',
    phonePrefix: '+599'
  },
  {
    label: 'Cyprus',
    value: 'CY',
    flag: '🇨🇾',
    phonePrefix: '+357'
  },
  {
    label: 'Czech Republic',
    value: 'CZ',
    flag: '🇨🇿',
    phonePrefix: '+420'
  },
  {
    label: 'Denmark',
    value: 'DK',
    flag: '🇩🇰',
    phonePrefix: '+45'
  },
  {
    label: 'Djibouti',
    value: 'DJ',
    flag: '🇩🇯',
    phonePrefix: '+253'
  },
  {
    label: 'Dominica',
    value: 'DM',
    flag: '🇩🇲',
    phonePrefix: '+1-767'
  },
  {
    label: 'Dominican Republic',
    value: 'DO',
    flag: '🇩🇴',
    phonePrefix: '+1-809 and 1-829'
  },
  {
    label: 'Ecuador',
    value: 'EC',
    flag: '🇪🇨',
    phonePrefix: '+593'
  },
  {
    label: 'Egypt',
    value: 'EG',
    flag: '🇪🇬',
    phonePrefix: '+20'
  },
  {
    label: 'El Salvador',
    value: 'SV',
    flag: '🇸🇻',
    phonePrefix: '+503'
  },
  {
    label: 'Equatorial Guinea',
    value: 'GQ',
    flag: '🇬🇶',
    phonePrefix: '+240'
  },
  {
    label: 'Eritrea',
    value: 'ER',
    flag: '🇪🇷',
    phonePrefix: '+291'
  },
  {
    label: 'Estonia',
    value: 'EE',
    flag: '🇪🇪',
    phonePrefix: '+372'
  },
  {
    label: 'Swaziland',
    value: 'SZ',
    flag: '🇸🇿',
    phonePrefix: '+268'
  },
  {
    label: 'Ethiopia',
    value: 'ET',
    flag: '🇪🇹',
    phonePrefix: '+251'
  },
  {
    label: 'Falkland Islands',
    value: 'FK',
    flag: '🇫🇰',
    phonePrefix: '+500'
  },
  {
    label: 'Faroe Islands',
    value: 'FO',
    flag: '🇫🇴',
    phonePrefix: '+298'
  },
  {
    label: 'Fiji',
    value: 'FJ',
    flag: '🇫🇯',
    phonePrefix: '+679'
  },
  {
    label: 'Finland',
    value: 'FI',
    flag: '🇫🇮',
    phonePrefix: '+358'
  },
  {
    label: 'France',
    value: 'FR',
    flag: '🇫🇷',
    phonePrefix: '+33'
  },
  {
    label: 'French Guiana',
    value: 'GF',
    flag: '🇬🇫',
    phonePrefix: '+594'
  },
  {
    label: 'French Polynesia',
    value: 'PF',
    flag: '🇵🇫',
    phonePrefix: '+689'
  },
  {
    label: 'French Southern Territories',
    value: 'TF',
    flag: '🇹🇫',
    phonePrefix: ''
  },
  {
    label: 'Gabon',
    value: 'GA',
    flag: '🇬🇦',
    phonePrefix: '+241'
  },
  {
    label: 'Gambia',
    value: 'GM',
    flag: '🇬🇲',
    phonePrefix: '+220'
  },
  {
    label: 'Georgia',
    value: 'GE',
    flag: '🇬🇪',
    phonePrefix: '+995'
  },
  {
    label: 'Germany',
    value: 'DE',
    flag: '🇩🇪',
    phonePrefix: '+49'
  },
  {
    label: 'Ghana',
    value: 'GH',
    flag: '🇬🇭',
    phonePrefix: '+233'
  },
  {
    label: 'Gibraltar',
    value: 'GI',
    flag: '🇬🇮',
    phonePrefix: '+350'
  },
  {
    label: 'Greece',
    value: 'GR',
    flag: '🇬🇷',
    phonePrefix: '+30'
  },
  {
    label: 'Greenland',
    value: 'GL',
    flag: '🇬🇱',
    phonePrefix: '+299'
  },
  {
    label: 'Grenada',
    value: 'GD',
    flag: '🇬🇩',
    phonePrefix: '+1-473'
  },
  {
    label: 'Guadeloupe',
    value: 'GP',
    flag: '🇬🇵',
    phonePrefix: '+590'
  },
  {
    label: 'Guam',
    value: 'GU',
    flag: '🇬🇺',
    phonePrefix: '+1-671'
  },
  {
    label: 'Guatemala',
    value: 'GT',
    flag: '🇬🇹',
    phonePrefix: '+502'
  },
  {
    label: 'Guernsey',
    value: 'GG',
    flag: '🇬🇬',
    phonePrefix: '+44-1481'
  },
  {
    label: 'Guinea',
    value: 'GN',
    flag: '🇬🇳',
    phonePrefix: '+224'
  },
  {
    label: 'Guinea-Bissau',
    value: 'GW',
    flag: '🇬🇼',
    phonePrefix: '+245'
  },
  {
    label: 'Guyana',
    value: 'GY',
    flag: '🇬🇾',
    phonePrefix: '+592'
  },
  {
    label: 'Haiti',
    value: 'HT',
    flag: '🇭🇹',
    phonePrefix: '+509'
  },
  {
    label: 'Heard Island and McDonald Islands',
    value: 'HM',
    flag: '🇭🇲',
    phonePrefix: '+ '
  },
  {
    label: 'Vatican',
    value: 'VA',
    flag: '🇻🇦',
    phonePrefix: '+379'
  },
  {
    label: 'Honduras',
    value: 'HN',
    flag: '🇭🇳',
    phonePrefix: '+504'
  },
  {
    label: 'Hong Kong',
    value: 'HK',
    flag: '🇭🇰',
    phonePrefix: '+852'
  },
  {
    label: 'Hungary',
    value: 'HU',
    flag: '🇭🇺',
    phonePrefix: '+36'
  },
  {
    label: 'Iceland',
    value: 'IS',
    flag: '🇮🇸',
    phonePrefix: '+354'
  },
  {
    label: 'India',
    value: 'IN',
    flag: '🇮🇳',
    phonePrefix: '+91'
  },
  {
    label: 'Indonesia',
    value: 'ID',
    flag: '🇮🇩',
    phonePrefix: '+62'
  },
  {
    label: 'Iran',
    value: 'IR',
    flag: '🇮🇷',
    phonePrefix: '+98'
  },
  {
    label: 'Iraq',
    value: 'IQ',
    flag: '🇮🇶',
    phonePrefix: '+964'
  },
  {
    label: 'Ireland',
    value: 'IE',
    flag: '🇮🇪',
    phonePrefix: '+353'
  },
  {
    label: 'Isle of Man',
    value: 'IM',
    flag: '🇮🇲',
    phonePrefix: '+44-1624'
  },
  {
    label: 'Israel',
    value: 'IL',
    flag: '🇮🇱',
    phonePrefix: '+972'
  },
  {
    label: 'Italy',
    value: 'IT',
    flag: '🇮🇹',
    phonePrefix: '+39'
  },
  {
    label: 'Jamaica',
    value: 'JM',
    flag: '🇯🇲',
    phonePrefix: '+1-876'
  },
  {
    label: 'Japan',
    value: 'JP',
    flag: '🇯🇵',
    phonePrefix: '+81'
  },
  {
    label: 'Jersey',
    value: 'JE',
    flag: '🇯🇪',
    phonePrefix: '+44-1534'
  },
  {
    label: 'Jordan',
    value: 'JO',
    flag: '🇯🇴',
    phonePrefix: '+962'
  },
  {
    label: 'Kazakhstan',
    value: 'KZ',
    flag: '🇰🇿',
    phonePrefix: '+7'
  },
  {
    label: 'Kenya',
    value: 'KE',
    flag: '🇰🇪',
    phonePrefix: '+254'
  },
  {
    label: 'Kiribati',
    value: 'KI',
    flag: '🇰🇮',
    phonePrefix: '+686'
  },
  {
    label: 'North Korea',
    value: 'KP',
    flag: '🇰🇵',
    phonePrefix: '+850'
  },
  {
    label: 'South Korea',
    value: 'KR',
    flag: '🇰🇷',
    phonePrefix: '+82'
  },
  {
    label: 'Kuwait',
    value: 'KW',
    flag: '🇰🇼',
    phonePrefix: '+965'
  },
  {
    label: 'Kyrgyzstan',
    value: 'KG',
    flag: '🇰🇬',
    phonePrefix: '+996'
  },
  {
    label: 'Laos',
    value: 'LA',
    flag: '🇱🇦',
    phonePrefix: '+856'
  },
  {
    label: 'Latvia',
    value: 'LV',
    flag: '🇱🇻',
    phonePrefix: '+371'
  },
  {
    label: 'Lebanon',
    value: 'LB',
    flag: '🇱🇧',
    phonePrefix: '+961'
  },
  {
    label: 'Lesotho',
    value: 'LS',
    flag: '🇱🇸',
    phonePrefix: '+266'
  },
  {
    label: 'Liberia',
    value: 'LR',
    flag: '🇱🇷',
    phonePrefix: '+231'
  },
  {
    label: 'Libya',
    value: 'LY',
    flag: '🇱🇾',
    phonePrefix: '+218'
  },
  {
    label: 'Liechtenstein',
    value: 'LI',
    flag: '🇱🇮',
    phonePrefix: '+423'
  },
  {
    label: 'Lithuania',
    value: 'LT',
    flag: '🇱🇹',
    phonePrefix: '+370'
  },
  {
    label: 'Luxembourg',
    value: 'LU',
    flag: '🇱🇺',
    phonePrefix: '+352'
  },
  {
    label: 'Macao',
    value: 'MO',
    flag: '🇲🇴',
    phonePrefix: '+853'
  },
  {
    label: 'Macedonia',
    value: 'MK',
    flag: '🇲🇰',
    phonePrefix: '+389'
  },
  {
    label: 'Madagascar',
    value: 'MG',
    flag: '🇲🇬',
    phonePrefix: '+261'
  },
  {
    label: 'Malawi',
    value: 'MW',
    flag: '🇲🇼',
    phonePrefix: '+265'
  },
  {
    label: 'Malaysia',
    value: 'MY',
    flag: '🇲🇾',
    phonePrefix: '+60'
  },
  {
    label: 'Maldives',
    value: 'MV',
    flag: '🇲🇻',
    phonePrefix: '+960'
  },
  {
    label: 'Mali',
    value: 'ML',
    flag: '🇲🇱',
    phonePrefix: '+223'
  },
  {
    label: 'Malta',
    value: 'MT',
    flag: '🇲🇹',
    phonePrefix: '+356'
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
    flag: '🇲🇭',
    phonePrefix: '+692'
  },
  {
    label: 'Martinique',
    value: 'MQ',
    flag: '🇲🇶',
    phonePrefix: '+596'
  },
  {
    label: 'Mauritania',
    value: 'MR',
    flag: '🇲🇷',
    phonePrefix: '+222'
  },
  {
    label: 'Mauritius',
    value: 'MU',
    flag: '🇲🇺',
    phonePrefix: '+230'
  },
  {
    label: 'Mayotte',
    value: 'YT',
    flag: '🇾🇹',
    phonePrefix: '+262'
  },
  {
    label: 'Mexico',
    value: 'MX',
    flag: '🇲🇽',
    phonePrefix: '+52'
  },
  {
    label: 'Micronesia',
    value: 'FM',
    flag: '🇫🇲',
    phonePrefix: '+691'
  },
  {
    label: 'Moldova',
    value: 'MD',
    flag: '🇲🇩',
    phonePrefix: '+373'
  },
  {
    label: 'Monaco',
    value: 'MC',
    flag: '🇲🇨',
    phonePrefix: '+377'
  },
  {
    label: 'Mongolia',
    value: 'MN',
    flag: '🇲🇳',
    phonePrefix: '+976'
  },
  {
    label: 'Montenegro',
    value: 'ME',
    flag: '🇲🇪',
    phonePrefix: '+382'
  },
  {
    label: 'Montserrat',
    value: 'MS',
    flag: '🇲🇸',
    phonePrefix: '+1-664'
  },
  {
    label: 'Morocco',
    value: 'MA',
    flag: '🇲🇦',
    phonePrefix: '+212'
  },
  {
    label: 'Mozambique',
    value: 'MZ',
    flag: '🇲🇿',
    phonePrefix: '+258'
  },
  {
    label: 'Myanmar',
    value: 'MM',
    flag: '🇲🇲',
    phonePrefix: '+95'
  },
  {
    label: 'Namibia',
    value: 'NA',
    flag: '🇳🇦',
    phonePrefix: '+264'
  },
  {
    label: 'Nauru',
    value: 'NR',
    flag: '🇳🇷',
    phonePrefix: '+674'
  },
  {
    label: 'Nepal',
    value: 'NP',
    flag: '🇳🇵',
    phonePrefix: '+977'
  },
  {
    label: 'Netherlands',
    value: 'NL',
    flag: '🇳🇱',
    phonePrefix: '+31'
  },
  {
    label: 'New Caledonia',
    value: 'NC',
    flag: '🇳🇨',
    phonePrefix: '+687'
  },
  {
    label: 'New Zealand',
    value: 'NZ',
    flag: '🇳🇿',
    phonePrefix: '+64'
  },
  {
    label: 'Nicaragua',
    value: 'NI',
    flag: '🇳🇮',
    phonePrefix: '+505'
  },
  {
    label: 'Niger',
    value: 'NE',
    flag: '🇳🇪',
    phonePrefix: '+227'
  },
  {
    label: 'Nigeria',
    value: 'NG',
    flag: '🇳🇬',
    phonePrefix: '+234'
  },
  {
    label: 'Niue',
    value: 'NU',
    flag: '🇳🇺',
    phonePrefix: '+683'
  },
  {
    label: 'Norfolk Island',
    value: 'NF',
    flag: '🇳🇫',
    phonePrefix: '+672'
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
    flag: '🇲🇵',
    phonePrefix: '+1-670'
  },
  {
    label: 'Norway',
    value: 'NO',
    flag: '🇳🇴',
    phonePrefix: '+47'
  },
  {
    label: 'Oman',
    value: 'OM',
    flag: '🇴🇲',
    phonePrefix: '+968'
  },
  {
    label: 'Pakistan',
    value: 'PK',
    flag: '🇵🇰',
    phonePrefix: '+92'
  },
  {
    label: 'Palau',
    value: 'PW',
    flag: '🇵🇼',
    phonePrefix: '+680'
  },
  {
    label: 'Palestinian Territory',
    value: 'PS',
    flag: '🇵🇸',
    phonePrefix: '+970'
  },
  {
    label: 'Panama',
    value: 'PA',
    flag: '🇵🇦',
    phonePrefix: '+507'
  },
  {
    label: 'Papua New Guinea',
    value: 'PG',
    flag: '🇵🇬',
    phonePrefix: '+675'
  },
  {
    label: 'Paraguay',
    value: 'PY',
    flag: '🇵🇾',
    phonePrefix: '+595'
  },
  {
    label: 'Peru',
    value: 'PE',
    flag: '🇵🇪',
    phonePrefix: '+51'
  },
  {
    label: 'Philippines',
    value: 'PH',
    flag: '🇵🇭',
    phonePrefix: '+63'
  },
  {
    label: 'Pitcairn',
    value: 'PN',
    flag: '🇵🇳',
    phonePrefix: '+870'
  },
  {
    label: 'Poland',
    value: 'PL',
    flag: '🇵🇱',
    phonePrefix: '+48'
  },
  {
    label: 'Portugal',
    value: 'PT',
    flag: '🇵🇹',
    phonePrefix: '+351'
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
    flag: '🇵🇷',
    phonePrefix: '+1-787 and 1-939'
  },
  {
    label: 'Qatar',
    value: 'QA',
    flag: '🇶🇦',
    phonePrefix: '+974'
  },
  {
    label: 'Reunion',
    value: 'RE',
    flag: '🇷🇪',
    phonePrefix: '+262'
  },
  {
    label: 'Romania',
    value: 'RO',
    flag: '🇷🇴',
    phonePrefix: '+40'
  },
  {
    label: 'Russia',
    value: 'RU',
    flag: '🇷🇺',
    phonePrefix: '+7'
  },
  {
    label: 'Rwanda',
    value: 'RW',
    flag: '🇷🇼',
    phonePrefix: '+250'
  },
  {
    label: 'Saint Barthelemy',
    value: 'BL',
    flag: '🇧🇱',
    phonePrefix: '+590'
  },
  {
    label: 'Saint Helena',
    value: 'SH',
    flag: '🇸🇭',
    phonePrefix: '+290'
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'KN',
    flag: '🇰🇳',
    phonePrefix: '+1-869'
  },
  {
    label: 'Saint Lucia',
    value: 'LC',
    flag: '🇱🇨',
    phonePrefix: '+1-758'
  },
  {
    label: 'Saint Martin',
    value: 'MF',
    flag: '🇲🇫',
    phonePrefix: '+590'
  },
  {
    label: 'Saint Pierre and Miquelon',
    value: 'PM',
    flag: '🇵🇲',
    phonePrefix: '+508'
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'VC',
    flag: '🇻🇨',
    phonePrefix: '+1-784'
  },
  {
    label: 'Samoa',
    value: 'WS',
    flag: '🇼🇸',
    phonePrefix: '+685'
  },
  {
    label: 'San Marino',
    value: 'SM',
    flag: '🇸🇲',
    phonePrefix: '+378'
  },
  {
    label: 'Sao Tome and Principe',
    value: 'ST',
    flag: '🇸🇹',
    phonePrefix: '+239'
  },
  {
    label: 'Saudi Arabia',
    value: 'SA',
    flag: '🇸🇦',
    phonePrefix: '+966'
  },
  {
    label: 'Senegal',
    value: 'SN',
    flag: '🇸🇳',
    phonePrefix: '+221'
  },
  {
    label: 'Serbia',
    value: 'RS',
    flag: '🇷🇸',
    phonePrefix: '+381'
  },
  {
    label: 'Seychelles',
    value: 'SC',
    flag: '🇸🇨',
    phonePrefix: '+248'
  },
  {
    label: 'Sierra Leone',
    value: 'SL',
    flag: '🇸🇱',
    phonePrefix: '+232'
  },
  {
    label: 'Singapore',
    value: 'SG',
    flag: '🇸🇬',
    phonePrefix: '+65'
  },
  {
    label: 'Sint Maarten',
    value: 'SX',
    flag: '🇸🇽',
    phonePrefix: '+599'
  },
  {
    label: 'Slovakia',
    value: 'SK',
    flag: '🇸🇰',
    phonePrefix: '+421'
  },
  {
    label: 'Slovenia',
    value: 'SI',
    flag: '🇸🇮',
    phonePrefix: '+386'
  },
  {
    label: 'Solomon Islands',
    value: 'SB',
    flag: '🇸🇧',
    phonePrefix: '+677'
  },
  {
    label: 'Somalia',
    value: 'SO',
    flag: '🇸🇴',
    phonePrefix: '+252'
  },
  {
    label: 'South Africa',
    value: 'ZA',
    flag: '🇿🇦',
    phonePrefix: '+27'
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
    flag: '🇬🇸',
    phonePrefix: ''
  },
  {
    label: 'South Sudan',
    value: 'SS',
    flag: '🇸🇸',
    phonePrefix: '+211'
  },
  {
    label: 'Spain',
    value: 'ES',
    flag: '🇪🇸',
    phonePrefix: '+34'
  },
  {
    label: 'Sri Lanka',
    value: 'LK',
    flag: '🇱🇰',
    phonePrefix: '+94'
  },
  {
    label: 'Sudan',
    value: 'SD',
    flag: '🇸🇩',
    phonePrefix: '+249'
  },
  {
    label: 'Surilabel',
    value: 'SR',
    flag: '🇸🇷',
    phonePrefix: '+597'
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'SJ',
    flag: '🇸🇯',
    phonePrefix: '+47'
  },
  {
    label: 'Sweden',
    value: 'SE',
    flag: '🇸🇪',
    phonePrefix: '+46'
  },
  {
    label: 'Switzerland',
    value: 'CH',
    flag: '🇨🇭',
    phonePrefix: '+41'
  },
  {
    label: 'Syria',
    value: 'SY',
    flag: '🇸🇾',
    phonePrefix: '+963'
  },
  {
    label: 'Taiwan',
    value: 'TW',
    flag: '🇹🇼',
    phonePrefix: '+886'
  },
  {
    label: 'Tajikistan',
    value: 'TJ',
    flag: '🇹🇯',
    phonePrefix: '+992'
  },
  {
    label: 'Tanzania',
    value: 'TZ',
    flag: '🇹🇿',
    phonePrefix: '+255'
  },
  {
    label: 'Thailand',
    value: 'TH',
    flag: '🇹🇭',
    phonePrefix: '+66'
  },
  {
    label: 'East Timor',
    value: 'TL',
    flag: '🇹🇱',
    phonePrefix: '+670'
  },
  {
    label: 'Togo',
    value: 'TG',
    flag: '🇹🇬',
    phonePrefix: '+228'
  },
  {
    label: 'Tokelau',
    value: 'TK',
    flag: '🇹🇰',
    phonePrefix: '+690'
  },
  {
    label: 'Tonga',
    value: 'TO',
    flag: '🇹🇴',
    phonePrefix: '+676'
  },
  {
    label: 'Trinidad and Tobago',
    value: 'TT',
    flag: '🇹🇹',
    phonePrefix: '+1-868'
  },
  {
    label: 'Tunisia',
    value: 'TN',
    flag: '🇹🇳',
    phonePrefix: '+216'
  },
  {
    label: 'Turkey',
    value: 'TR',
    flag: '🇹🇷',
    phonePrefix: '+90'
  },
  {
    label: 'Turkmenistan',
    value: 'TM',
    flag: '🇹🇲',
    phonePrefix: '+993'
  },
  {
    label: 'Turks and Caicos Islands',
    value: 'TC',
    flag: '🇹🇨',
    phonePrefix: '+1-649'
  },
  {
    label: 'Tuvalu',
    value: 'TV',
    flag: '🇹🇻',
    phonePrefix: '+688'
  },
  {
    label: 'Uganda',
    value: 'UG',
    flag: '🇺🇬',
    phonePrefix: '+256'
  },
  {
    label: 'Ukraine',
    value: 'UA',
    flag: '🇺🇦',
    phonePrefix: '+380'
  },
  {
    label: 'United Arab Emirates',
    value: 'AE',
    flag: '🇦🇪',
    phonePrefix: '+971'
  },
  {
    label: 'United Kingdom',
    value: 'GB',
    flag: '🇬🇧',
    phonePrefix: '+44'
  },
  {
    label: 'United States Minor Outlying Islands',
    value: 'UM',
    flag: '🇺🇲',
    phonePrefix: '+1'
  },
  US_COUNTRY,
  {
    label: 'Uruguay',
    value: 'UY',
    flag: '🇺🇾',
    phonePrefix: '+598'
  },
  {
    label: 'Uzbekistan',
    value: 'UZ',
    flag: '🇺🇿',
    phonePrefix: '+998'
  },
  {
    label: 'Vanuatu',
    value: 'VU',
    flag: '🇻🇺',
    phonePrefix: '+678'
  },
  {
    label: 'Venezuela',
    value: 'VE',
    flag: '🇻🇪',
    phonePrefix: '+58'
  },
  {
    label: 'Vietnam',
    value: 'VN',
    flag: '🇻🇳',
    phonePrefix: '+84'
  },
  {
    label: 'British Virgin Islands',
    value: 'VG',
    flag: '🇻🇬',
    phonePrefix: '+1-284'
  },
  {
    label: 'U.S. Virgin Islands',
    value: 'VI',
    flag: '🇻🇮',
    phonePrefix: '+1-340'
  },
  {
    label: 'Wallis and Futuna',
    value: 'WF',
    flag: '🇼🇫',
    phonePrefix: '+681'
  },
  {
    label: 'Western Sahara',
    value: 'EH',
    flag: '🇪🇭',
    phonePrefix: '+212'
  },
  {
    label: 'Yemen',
    value: 'YE',
    flag: '🇾🇪',
    phonePrefix: '+967'
  },
  {
    label: 'Zambia',
    value: 'ZM',
    flag: '🇿🇲',
    phonePrefix: '+260'
  },
  {
    label: 'Zimbabwe',
    value: 'ZW',
    flag: '🇿🇼',
    phonePrefix: '+263'
  }
];
